import { z } from "zod";
// ─── Share Link ────────────────────────────────────────────
export const ShareLinkSchema = z.object({
    id: z.string().uuid(),
    documentId: z.string().uuid(),
    token: z.string().min(1),
    accessType: z.enum(["view", "download"]),
    requiresEmail: z.boolean().default(false),
    hasPassword: z.boolean().default(false),
    expiresAt: z.string().datetime().nullable(),
    revokedAt: z.string().datetime().nullable(),
    createdBy: z.string().email().nullable(),
    createdAt: z.string().datetime(),
    shareUrl: z.string().url().optional(),
});
export const ShareLinkCreateSchema = z.object({
    documentId: z.string().uuid(),
    accessType: z.enum(["view", "download"]).default("view"),
    requiresEmail: z.boolean().default(false),
    password: z.string().min(6).max(100).optional(),
    expiresAt: z.string().datetime().optional(),
});
export const ShareLinkListResponseSchema = z.object({
    shares: z.array(ShareLinkSchema),
});
export const ShareLinkCreateResponseSchema = ShareLinkSchema.extend({
    shareUrl: z.string().url(),
});
export const ShareLinkRevokeResponseSchema = z.object({
    revoked: z.literal(true),
    id: z.string().uuid(),
});
export const ShareLinkDeleteResponseSchema = z.object({
    deleted: z.literal(true),
    id: z.string().uuid(),
});
// ─── Access ────────────────────────────────────────────────
export const ShareAccessSchema = z.object({
    token: z.string().min(1),
    email: z.string().email().optional(),
    password: z.string().optional(),
});
export const ShareAccessResponseSchema = z.object({
    title: z.string(),
    filename: z.string(),
    accessType: z.enum(["view", "download"]),
    viewUrl: z.string().url(),
    canDownload: z.boolean(),
});
export const ShareDownloadResponseSchema = z.object({
    downloadUrl: z.string().url(),
    filename: z.string(),
});
export const ShareAuditSchema = z.object({
    id: z.string().uuid(),
    shareLinkId: z.string().uuid(),
    action: z.enum(["viewed", "downloaded"]),
    accessorEmail: z.string().email().nullable(),
    ipAddress: z.string(),
    userAgent: z.string(),
    createdAt: z.string().datetime(),
});
export const ShareAuditListResponseSchema = z.object({
    audit: z.array(ShareAuditSchema),
});
//# sourceMappingURL=sharing.js.map